var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1809_5831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.42112 27.6113H0V31.5957H2.35915C2.31911 31.3382 2.29805 31.0744 2.29805 30.8058C2.29805 29.5983 2.7192 28.4878 3.42112 27.6113Z",
    fill: "#2776CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1038 31.5957L21.5095 27.6113H11.4155C12.1174 28.4878 12.5386 29.5983 12.5386 30.8058C12.5386 31.0744 12.5175 31.3381 12.4775 31.5957H20.1038Z",
    fill: "#2776CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2163 31.5954H25.7439C25.7038 31.3378 25.6828 31.0741 25.6828 30.8055C25.6828 27.9821 27.9797 25.6852 30.803 25.6852C32.0117 25.6852 33.1231 26.1071 33.9999 26.8101V18.8004H30.8694V1.99219H33.9999V0H25.7666V1.99219H28.8773V18.8004H26.7307L22.2163 31.5954Z",
    fill: "#2776CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41817 34.0004C9.18247 34.0004 10.6127 32.5702 10.6127 30.8059C10.6127 29.0416 9.18247 27.6113 7.41817 27.6113C5.65388 27.6113 4.22363 29.0416 4.22363 30.8059C4.22363 32.5702 5.65388 34.0004 7.41817 34.0004Z",
    fill: "#2776CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7686 32.0354C34.4443 30.4052 33.6705 28.5359 32.0403 27.8602C30.4101 27.1844 28.5408 27.9582 27.8651 29.5883C27.1894 31.2185 27.9631 33.0878 29.5934 33.7635C31.2236 34.4393 33.0929 33.6655 33.7686 32.0354Z",
    fill: "#2776CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.784 18.54H8.29342V20.9188H6.30123V18.54H3.83789V25.4862H10.784V18.54Z",
    fill: "#57B8EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.784 9.60156H8.29342V11.9803H6.30123V9.60156H3.83789V16.5477H10.784V9.60156Z",
    fill: "#2776CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2391 0.663086H12.7484V3.04189H10.7562V0.663086H8.29297V7.60924H15.2391V0.663086Z",
    fill: "#57B8EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2392 20.9188V18.54H12.7759V25.4862H19.722V18.54H17.2314V20.9188H15.2392Z",
    fill: "#57B8EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2392 11.9803V9.60156H12.7759V16.5477H19.722V9.60156H17.2314V11.9803H15.2392Z",
    fill: "#2776CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1809_5831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/Truck.686d850ad79e3f9c3e31fa4db38b3ca5.svg";
export { ForwardRef as ReactComponent };